import '../global';
class Rqst {
    constructor(input, init) {
        if (!new.target) {
            throw new TypeError(`Class constructor 'Request' cannot be invoked without 'new'`);
        }
        return new Request(input, init);
    }
}
const klass = Rqst;
export {
    klass as Request
};
export default klass;    //# sourceMappingURL=Request.js.map
